export const WORDS = [
  'sonho',
  'ética',
  'etnia',
  'assim',
  'crush',
  'vídeo',
  'fosse',
  'tempo',
  'carma',
  'linda',
  'fazer',
  'texto',
  'genro',
  'moral',
  'amigo',
  'sigma',
  'êxito',
  'piada',
  'então',
  'oxalá',
  'páreo',
  'honra',
  'mamãe',
  'ícone',
  'ajuda',
  'sanar',
  'índio',
  'burro',
  'calvo',
  'coroa',
  'graça',
  'posso',
  'porém',
  'sendo',
  'afeto',
  'pauta',
  'seara',
  'nicho',
  'vulgo',
  'sagaz',
  'ideia',
  'muito',
  'coisa',
  'âmago',
  'legal',
  'coçar',
  'verbo',
  'líder',
  'neném',
  'razão',
  'forte',
  'morte',
  'feliz',
  'ímpio',
  'boçal',
  'humor',
  'tênue',
  'sábia',
  'mexer',
  'cânon',
  'sobre',
  'cerne',
  'ontem',
  'estar',
  'limbo',
  'dengo',
  'mesmo',
  'aquém',
  'ouvir',
  'meses',
  'noite',
  'judeu',
  'nobre',
  'dogma',
  'mercê',
  'fútil',
  'quiçá',
  'expor',
  'justo',
  'ranço',
  'comum',
  'haver',
  'valor',
  'mútua',
  'vigor',
  'causa',
  'sorte',
  'credo',
  'ápice',
  'sutil',
  'força',
  'nossa',
  'ainda',
  'séria',
  'amiga',
  'fácil',
  'forma',
  'égide',
  'vício',
  'louco',
  'sonso',
  'pique',
  'reage',
  'todos',
  'valia',
  'leigo',
  'senso',
  'culto',
  'lagar',
  'união',
  'calma',
  'desde',
  'lugar',
  'óbice',
  'ordem',
  'pobre',
  'herói',
  'mútuo',
  'lenda',
  'temor',
  'manhã',
  'presa',
  'poder',
  'anexo',
  'insta',
  'ânimo',
  'ceder',
  'flozô',
  'chata',
  'seita',
  'salmo',
  'brisa',
  'ciclo',
  'certo',
  'grupo',
  'olhar',
  'foram',
  'falar',
  'abrir',
  'mágoa',
  'saber',
  'peixe',
  'áurea',
  'brega',
  'saúde',
  'terra',
  'ímpar',
  'velho',
  'puder',
  'prosa',
  'fugaz',
  'casta',
  'nosso',
  'frase',
  'crivo',
  'massa',
  'prole',
  'prumo',
  'santo',
  'juízo',
  'filho',
  'hábil',
  'desse',
  'fonte',
  'inato',
  'signo',
  'velar',
  'ânsia',
  'minha',
  'fomos',
  'marco',
  'plena',
  'dever',
  'saiba',
  'ponto',
  'adeus',
  'mundo',
  'acaso',
  'bravo',
  'regra',
  'vácuo',
  'audaz',
  'louça',
  'chato',
  'lapso',
  'pária',
  'falsa',
  'usura',
  'torpe',
  'gênio',
  'posto',
  'conta',
  'pódio',
  'viver',
  'ritmo',
  'velha',
  'rever',
  'sonsa',
  'local',
  'vivaz',
  'sábio',
  'devir',
  'casar',
  'tenaz',
  'óbvio',
  'apoio',
  'tédio',
  'atrás',
  'senil',
  'farão',
  'álibi',
  'tribo',
  'sítio',
  'furor',
  'fatal',
  'salve',
  'deixa',
  'jorro',
  'ciúme',
  'vezes',
  'crise',
  'noção',
  'vênia',
  'oásis',
  'pedir',
  'comer',
  'cunho',
  'meiga',
  'viril',
  'manga',
  'torço',
  'servo',
  'ávido',
  'parca',
  'pudor',
  'beata',
  'ébano',
  'pesar',
  'tendo',
  'possa',
  'areal',
  'sente',
  'pedra',
  'afins',
  'algoz',
  'combo',
  'outro',
  'tenho',
  'todas',
  'raiva',
  'verde',
  'falso',
  'áudio',
  'revés',
  'jovem',
  'carro',
  'acolá',
  'visão',
  'tanto',
  'cisão',
  'troço',
  'vemos',
  'criar',
  'pólis',
  'festa',
  'ativo',
  'sejam',
  'besta',
  'série',
  'chula',
  'estou',
  'flora',
  'ídolo',
  'lazer',
  'chuva',
  'sósia',
  'botar',
  'ideal',
  'banal',
  'vendo',
  'banzo',
  'sério',
  'magna',
  'êxodo',
  'tomar',
  'cheio',
  'praga',
  'glifo',
  'renda',
  'única',
  'fardo',
  'posse',
  'impor',
  'afago',
  'final',
  'átrio',
  'coesa',
  'agora',
  'tchau',
  'mudar',
  'átomo',
  'tenso',
  'vinha',
  'outra',
  'corpo',
  'vazio',
  'mirim',
  'terão',
  'atroz',
  'fusão',
  'finge',
  'gíria',
  'fluxo',
  'igual',
  'hiato',
  'mater',
  'vosso',
  'xinga',
  'podem',
  'ardor',
  'treta',
  'entre',
  'diabo',
  'plano',
  'maruá',
  'pariu',
  'psico',
  'dizer',
  'rapaz',
  'gueto',
  'rezar',
  'briga',
  'valha',
  'corja',
  'missa',
  'cetro',
  'caixa',
  'nação',
  'prado',
  'pular',
  'mangá',
  'livro',
  'claro',
  'terna',
  'dique',
  'conto',
  'cabal',
  'temos',
  'nunca',
  'pinho',
  'ateia',
  'digno',
  'malta',
  'chama',
  'touro',
  'óbito',
  'longe',
  'setor',
  'tende',
  'sumir',
  'reúso',
  'trama',
  'tutor',
  'sarça',
  'grato',
  'bruxa',
  'tecer',
  'épica',
  'covil',
  'turma',
  'demos',
  'adoro',
  'livre',
  'super',
  'pagão',
  'denso',
  'vital',
  'burra',
  'móvel',
  'manso',
  'dinda',
  'ambos',
  'visar',
  'peste',
  'levar',
  'lindo',
  'vilão',
  'brava',
  'pegar',
  'garbo',
  'quase',
  'trago',
  'irmão',
  'papel',
  'alado',
  'cesta',
  'reaja',
  'morro',
  'sexta',
  'dando',
  'brabo',
  'falta',
  'tosco',
  'visse',
  'preso',
  'terno',
  'pajem',
  'bazar',
  'xingo',
  'cutia',
  'abriu',
  'elite',
  'rádio',
  'temer',
  'ponha',
  'sulco',
  'dócil',
  'pitéu',
  'praia',
  'sarau',
  'vírus',
  'anima',
  'ligar',
  'coeso',
  'cruel',
  'drama',
  'troca',
  'nesta',
  'itens',
  'detém',
  'parda',
  'preço',
  'saldo',
  'vimos',
  'exame',
  'nasci',
  'sinto',
  'doida',
  'desta',
  'junco',
  'amada',
  'sigam',
  'brado',
  'capaz',
  'relva',
  'ágape',
  'fizer',
  'ébrio',
  'truta',
  'mosto',
  'irmãs',
  'praxe',
  'magia',
  'pífio',
  'refém',
  'doido',
  'zoada',
  'enfim',
  'cópia',
  'alada',
  'coser',
  'rango',
  'bônus',
  'daqui',
  'único',
  'tremo',
  'tenro',
  'roupa',
  'madre',
  'campo',
  'fluir',
  'matiz',
  'elmos',
  'pulha',
  'facho',
  'árduo',
  'mexeu',
  'enche',
  'punha',
  'aviso',
  'porta',
  'cozer',
  'golpe',
  'desce',
  'ótica',
  'façam',
  'xucro',
  'mesma',
  'estes',
  'jurar',
  'turco',
  'assaz',
  'vamos',
  'úteis',
  'lesão',
  'fatos',
  'pacto',
  'pouco',
  'terem',
  'horto',
  'reino',
  'manta',
  'jejum',
  'glosa',
  'beijo',
  'douto',
  'antes',
  'turra',
  'monte',
  'parte',
  'épico',
  'letra',
  'feito',
  'doído',
  'inata',
  'braba',
  'saúva',
  'facto',
  'casão',
  'farsa',
  'aluno',
  'essas',
  'emana',
  'disse',
  'reles',
  'prevê',
  'extra',
  'primo',
  'faria',
  'digna',
  'sinhá',
  'garra',
  'risco',
  'hepta',
  'light',
  'censo',
  'apego',
  'estão',
  'tocar',
  'toldo',
  'ocaso',
  'exato',
  'calmo',
  'culpa',
  'tento',
  'privê',
  'muita',
  'remir',
  'antro',
  'tenha',
  'dúbio',
  'gente',
  'calor',
  'meros',
  'grata',
  'vocês',
  'pilar',
  'atual',
  'perco',
  'escol',
  'jazia',
  'poeta',
  'alçar',
  'xeque',
  'deusa',
  'pífia',
  'piruá',
  'bater',
  'breve',
  'selar',
  'paiol',
  'feita',
  'plumo',
  'andar',
  'naipe',
  'favor',
  'deter',
  'norma',
  'mimos',
  'ávida',
  'segue',
  'trupe',
  'fruta',
  'poema',
  'culta',
  'jogar',
  'fraco',
  'pules',
  'macro',
  'volta',
  'hiper',
  'vetor',
  'adega',
  'parvo',
  'monge',
  'tirar',
  'apraz',
  'bordo',
  'maçom',
  'moção',
  'acesa',
  'certa',
  'pujar',
  'avião',
  'tíbio',
  'suave',
  'navio',
  'prova',
  'opção',
  'fauna',
  'cisma',
  'zelar',
  'pelas',
  'cútis',
  'irado',
  'sabia',
  'beber',
  'afora',
  'faixa',
  'leite',
  'vulto',
  'fator',
  'modal',
  'jegue',
  'traço',
  'aceso',
  'seixo',
  'tenra',
  'folga',
  'gerar',
  'short',
  'marca',
  'alude',
  'apois',
  'toque',
  'feixe',
  'dessa',
  'manto',
  'ótimo',
  'pardo',
  'versa',
  'tição',
  'imune',
  'fases',
  'lápis',
  'quota',
  'vigia',
  'moías',
  'maior',
  'coral',
  'fedor',
  'autos',
  'bilha',
  'havia',
  'prezo',
  'sabão',
  'valeu',
  'prazo',
  'ereto',
  'labor',
  'salvo',
  'ditos',
  'pomar',
  'porte',
  'plebe',
  'amplo',
  'sanha',
  'débil',
  'macio',
  'vindo',
  'caçar',
  'canso',
  'prima',
  'pazes',
  'autor',
  'tinha',
  'sabor',
  'nessa',
  'opina',
  'darás',
  'cosmo',
  'choro',
  'meigo',
  'bedel',
  'skate',
  'mimar',
  'boato',
  'parco',
  'pampa',
  'amena',
  'rumos',
  'áureo',
  'solto',
  'forro',
  'atuar',
  'seiva',
  'rival',
  'cerca',
  'banco',
  'ardil',
  'vazia',
  'algum',
  'neste',
  'opaco',
  'bruma',
  'ázimo',
  'árdua',
  'couro',
  'ações',
  'tarde',
  'prata',
  'cálix',
  'dupla',
  'época',
  'pleno',
  'lavra',
  'rogar',
  'verem',
  'altar',
  'ampla',
  'guapa',
  'aloca',
  'turba',
  'ábaco',
  'tênis',
  'clone',
  'perto',
  'nódoa',
  'densa',
  'côrte',
  'lição',
  'podar',
  'aliás',
  'vocal',
  'busca',
  'olhos',
  'grife',
  'traga',
  'fugir',
  'ative',
  'preza',
  'mines',
  'blusa',
  'faraó',
  'adiar',
  'atlas',
  'viria',
  'ganha',
  'retro',
  'draga',
  'ítalo',
  'chave',
  'dança',
  'bruto',
  'lidos',
  'folia',
  'ruins',
  'panto',
  'matar',
  'perdi',
  'firme',
  'louca',
  'garoa',
  'tacha',
  'ágata',
  'agudo',
  'parar',
  'abaré',
  'dorme',
  'gerir',
  'advém',
  'fecho',
  'reajo',
  'forem',
  'nesse',
  'pelar',
  'amolo',
  'choça',
  'sacro',
  'serem',
  'porco',
  'burla',
  'farra',
  'magno',
  'hurra',
  'bando',
  'saída',
  'ruína',
  'balda',
  'cafés',
  'vazou',
  'exala',
  'bílis',
  'pimba',
  'aloés',
  'pança',
  'refiz',
  'troco',
  'rubro',
  'cacei',
  'coube',
  'carta',
  'ameno',
  'motim',
  'babau',
  'gabar',
  'símio',
  'barra',
  'saruê',
  'mirra',
  'teste',
  'ogiva',
  'andor',
  'podre',
  'calço',
  'morri',
  'clava',
  'curso',
  'buril',
  'nesga',
  'focar',
  'astro',
  'amora',
  'sexto',
  'trato',
  'citar',
  'trono',
  'dúbia',
  'tente',
  'bispo',
  'árido',
  'crias',
  'leito',
  'seção',
  'causo',
  'luaus',
  'tiver',
  'idoso',
  'voraz',
  'patuá',
  'casto',
  'prato',
  'álamo',
  'souto',
  'pasto',
  'venho',
  'teria',
  'turnê',
  'abati',
  'rácio',
  'narco',
  'leiam',
  'estás',
  'fruto',
  'moura',
  'féria',
  'envie',
  'vexar',
  'anelo',
  'venha',
  'acode',
  'gosta',
  'calda',
  'selva',
  'messe',
  'palha',
  'ornar',
  'irmos',
  'tongo',
  'tanso',
  'truco',
  'brasa',
  'rolar',
  'rocha',
  'fuçar',
  'bruta',
  'ungir',
  'viela',
  'letal',
  'fauno',
  'podia',
  'dormi',
  'chova',
  'graxa',
  'aérea',
  'nariz',
  'pecha',
  'mocho',
  'folha',
  'julgo',
  'verme',
  'ambas',
  'cores',
  'reagi',
  'segui',
  'supor',
  'esses',
  'pesei',
  'volto',
  'dizem',
  'deque',
  'expus',
  'cravo',
  'verba',
  'farta',
  'fitar',
  'bolão',
  'teceu',
  'afaga',
  'devem',
  'filme',
  'entes',
  'leões',
  'bolso',
  'vovós',
  'feira',
  'civis',
  'junta',
  'passa',
  'noivo',
  'clara',
  'ninho',
  'urubu',
  'morto',
  'banho',
  'serra',
  'mente',
  'geria',
]
